import { IRiskOption } from "src/core/constants/options";
import { CustomRiskLevel } from "src/core/constants/risk";
import { ListElementWithRisk } from "src/core/gql/graphql";
import { mapRiskCategory } from "src/core/mappers/risk-category.mapper";

export const mapLegalTypesToRiskOptions = (legalTypes: ListElementWithRisk[]): IRiskOption[] => {
  return legalTypes.map((legalType) => {
    const defaultRisk = legalType.riskValues.find((risk) => risk.key === "default");
    const risk = defaultRisk ? mapRiskCategory(defaultRisk.riskCategory) : CustomRiskLevel.LOW;

    return {
      id: legalType.id,
      value: legalType.code,
      label: legalType.name,
      risk,
    };
  });
};
